import { ValidationResult, ValidatorOptions } from '.';
import { RequiredValidator } from './required.validator';
import { Validator } from './validator';

export class IpAddressValidator extends Validator {
    /**
     * Validates IP address format
     * @param value - The IP address to validate
     * @returns True if valid IP address
     */
    public validate(value: string, options: ValidatorOptions) {
        const minOctets = 4;
        if (!value || value.length < 1) {
            return new RequiredValidator().validate(value, options);
        }

        // Allow partial IP addresses during typing
        const segments = value.split('.');

        // Must have 1-4 segments
        if (segments.length < minOctets || segments.length > 4) {
            return new ValidationResult(false, 'IP address must have 4 segments');
        }

        // Each segment must be valid
        for (let i = 0; i < segments.length; i++) {
            const segment = segments[i];

            // The last segment cannot be empty
            if (i === 3 && segment === '') {
                return new ValidationResult(false, 'The last segment cannot be empty');
            }

            // Empty segments are allowed during typing (e.g., "192.")
            if (segment === '') {
                continue;
            }

            // Must be numeric
            if (!/^\d+$/.test(segment)) {
                return new ValidationResult(
                    false,
                    'One of the segments has a non-numeric character'
                );
            }

            // Must be 1-3 digits
            if (segment.length > 3) {
                return new ValidationResult(false, 'One of the segments is greater than 3 digits');
            }

            // Must be 0-255
            const num = parseInt(segment, 10);
            if (num < 0) {
                return new ValidationResult(false, 'One of the segments is not a valid number');
            }
            if (num > 255) {
                return new ValidationResult(false, 'One of the segments is greater than 255');
            }
        }

        return new ValidationResult(true);
    }
}
